import {Toast} from 'vant'
export default {
  ymDateLast: function (obj) {
    var date = new Date(obj)
    var y = (1900 + date.getYear()).toString()
    var m = '0' + (date.getMonth() + 1)
    return y.substring(y.length - 2, y.length) + '-' + m.substring(m.length - 2, m.length)
  },
  ymDate: function (obj) {
    var date = new Date(obj)
    var y = 1900 + date.getYear()
    var m = '0' + (date.getMonth() + 1)
    return y + '-' + m.substring(m.length - 2, m.length)
  },
  baseURL: function () {
    return process.env.BASE_URL
  },
  ymdDate: function (obj, symbol = '.') {
    if (!obj) {
      return ''
    }
    var date = new Date(obj)
    var y = 1900 + date.getYear()
    var m = '0' + (date.getMonth() + 1)
    var d = '0' + date.getDate()
    return y + symbol + m.substring(m.length - 2, m.length) + symbol + d.substring(d.length - 2, d.length)
  },
  mdDate: function (obj, num) {
    var date = new Date(obj.getTime() + ((num || 0) * 24 * 60 * 60 * 1000))
    var m = '' + (date.getMonth() + 1)
    var d = '0' + date.getDate()
    return m + '-' + d.substring(d.length - 2, d.length)
  },
  mDate: function (obj, num) {
    var date = new Date(obj)
    var m = '' + (date.getMinutes() + 1)
    return m
  },
  autoFormatDate (obj) {
    if (!obj) return ''
    let unixtimestamp = new Date(obj)
    let year = unixtimestamp.getFullYear()
    let month = '0' + (unixtimestamp.getMonth() + 1)
    let date = '0' + unixtimestamp.getDate()
    let hour = '0' + unixtimestamp.getHours()
    let minute = '0' + unixtimestamp.getMinutes()
    let second = '0' + unixtimestamp.getSeconds()
    let cTime = new Date()
    let cYear = cTime.getFullYear()
    let cMonth = '0' + (cTime.getMonth() + 1)
    let cDate = '0' + cTime.getDate()
    let str = year + '-' + month.substring(month.length - 2, month.length) + '-' + date.substring(date.length - 2, date.length) + ' '
    let dayList = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
    if (year === cYear) {
      if (month === cMonth) {
        if (date === cDate) {
          str = ''
        } else if (cDate - date < 6) {
          if (cDate - date === 1) {
            str = '昨天'
          } else {
            str = dayList[unixtimestamp.getDay()]
          }
        }
      }
    }
    return str + hour.substring(hour.length - 2, hour.length) + ':' +
      minute.substring(minute.length - 2, minute.length) + ':' +
      second.substring(second.length - 2, second.length)
  },
  priceFormat (value) {
    // eslint-disable-next-line eqeqeq
    return value ? (value / 100 + '.00') == value / 100 ? value / 100 + '.00' : ((value / 100).toString() + '0') == value / 100 && ((value / 100).toString() + '0').split('.')[1].length <= 2 ? (value / 100).toString() + '0' : (value / 100).toString() : '0.00'
  },
  priceFormat2 (value) {
    let num = this.priceFormat(value).split('.')[0]
    let temp = num.length % 3
    switch (temp) {
      case 1:
        num = '00' + num
        break
      case 2:
        num = '0' + num
        break
    }
    return (num.match(/\d{3}/g).join(',').replace(/^0+/, '') || '0') + '.' + this.priceFormat(value).split('.')[1]
  },
  copy (data) {
    let oInput = document.createElement('input')
    oInput.value = data
    document.body.appendChild(oInput)
    oInput.select() // 选择对象;
    oInput.setSelectionRange(0, oInput.value.length)
    document.execCommand('Copy') // 执行浏览器复制命令
    Toast('复制成功')
    oInput.remove()
  },
  strlen (str = '') {
    let len = 0
    for (let i = 0; i < str.length; i++) {
      let c = str.charCodeAt(i)
      if ((c >= 0x0001 && c <= 0x007e) || (c >= 0xff60 && c <= 0xff9f)) {
        len++
      } else {
        len += 2
      }
      if (len > 16) {
        return i
      }
    }
    return 16
  },
  ymdhmsDate: function (obj) {
    if (!obj) return ''
    var unixtimestamp = new Date(obj)
    var year = 1900 + unixtimestamp.getYear()
    var month = '0' + (unixtimestamp.getMonth() + 1)
    var date = '0' + unixtimestamp.getDate()
    var hour = '0' + unixtimestamp.getHours()
    var minute = '0' + unixtimestamp.getMinutes()
    var second = '0' + unixtimestamp.getSeconds()
    return year + '-' + month.substring(month.length - 2, month.length) + '-' + date.substring(date.length - 2, date.length) +
      ' ' + hour.substring(hour.length - 2, hour.length) + ':' +
      minute.substring(minute.length - 2, minute.length) + ':' +
      second.substring(second.length - 2, second.length)
  },
  mdhmDate: function (obj) {
    if (!obj) return ''
    var unixtimestamp = new Date(obj)
    var month = '0' + (unixtimestamp.getMonth() + 1)
    var date = '0' + unixtimestamp.getDate()
    var hour = '' + unixtimestamp.getHours()
    var minute = '' + unixtimestamp.getMinutes()
    return month.substring(month.length - 2, month.length) + '/' + date.substring(date.length - 2, date.length) +
      ' ' + hour.substring(hour.length - 2, hour.length) + ':' +
      minute.substring(minute.length - 2, minute.length)
  },
  mdhmsDate: function (obj) {
    if (!obj) return ''
    var unixtimestamp = new Date(obj)
    var month = '0' + (unixtimestamp.getMonth() + 1)
    var date = '0' + unixtimestamp.getDate()
    var hour = '0' + unixtimestamp.getHours()
    var minute = '0' + unixtimestamp.getMinutes()
    var second = '0' + unixtimestamp.getSeconds()
    return month.substring(month.length - 2, month.length) + '/' + date.substring(date.length - 2, date.length) +
      ' ' + hour.substring(hour.length - 2, hour.length) + ':' +
      minute.substring(minute.length - 2, minute.length) + ':' +
      second.substring(second.length - 2, second.length)
  },
  fixNum (num, pattern) {
    let strarr = num ? num.toString().split('.') : ['0']
    let fmtarr = pattern ? pattern.split('.') : ['']
    let retstr = ''
    // 整数部分
    let str = strarr[0]
    let fmt = fmtarr[0]
    let i = str.length - 1
    let comma = false
    for (let f = fmt.length - 1; f >= 0; f--) {
      switch (fmt.substr(f, 1)) {
        case '#':
          if (i >= 0) retstr = str.substr(i--, 1) + retstr
          break
        case '0':
          if (i >= 0) retstr = str.substr(i--, 1) + retstr
          else retstr = '0' + retstr
          break
        case ',':
          comma = true
          retstr = ',' + retstr
          break
      }
    }
    if (i >= 0) {
      if (comma) {
        let l = str.length
        for (;i >= 0; i--) {
          retstr = str.substr(i, 1) + retstr
          // eslint-disable-next-line eqeqeq
          if (i > 0 && ((l - i) % 3) == 0) retstr = ',' + retstr
        }
      } else retstr = str.substr(0, i + 1) + retstr
    }
    retstr = retstr + '.'
    // 处理小数部分
    str = strarr.length > 1 ? strarr[1] : ''
    fmt = fmtarr.length > 1 ? fmtarr[1] : ''
    i = 0
    for (let f = 0; f < fmt.length; f++) {
      switch (fmt.substr(f, 1)) {
        case '#':
          if (i < str.length) retstr += str.substr(i++, 1)
          break
        case '0':
          if (i < str.length) retstr += str.substr(i++, 1)
          else retstr += '0'
          break
      }
    }
    return retstr.replace(/^,+/, '').replace(/\.$/, '')
  }
}
